module.exports = __webpack_public_path__ + "static/media/Event-08.ea9c2dd4.svg";